import {
  GET_DATA_PROP_DEV,
  GET_TIPE_PROP_DEV,
  SET_LOADING_DATA_PROP_DEV,
  SET_LOADING_TIPE_PROP_DEV,
  SET_PAGINATION_DATA_PROP_DEV,
  SET_PAGINATION_TIPE_PROP_DEV,
} from '../constant';

const initialState = {
  tipe: [],
  loadingTipe: false,
  tipePagination: 0,
  totalTipe: 0,
  data: [],
  loadingData: false,
  dataPagination: 0,
  totalData: 0,
};

const propertyDevReducer = function (state = initialState, action) {
  switch (action.type) {
    case SET_LOADING_TIPE_PROP_DEV: {
      return {
        ...state,
        loadingTipe: action?.payload,
      };
    }
    case SET_PAGINATION_TIPE_PROP_DEV: {
      return {
        ...state,
        tipePagination: action?.payload,
      };
    }
    case GET_TIPE_PROP_DEV: {
      return {
        ...state,
        tipe: action?.payload?.data,
        totalTipe: action?.payload?.total,
        loadingTipe: false,
      };
    }
    case SET_LOADING_DATA_PROP_DEV: {
      return {
        ...state,
        loadingData: action?.payload,
      };
    }
    case SET_PAGINATION_DATA_PROP_DEV: {
      return {
        ...state,
        dataPagination: action?.payload,
      };
    }
    case GET_DATA_PROP_DEV: {
      return {
        ...state,
        data: action?.payload?.data || [],
        totalData: action?.payload?.total,
        loadingData: false,
      };
    }
    default: {
      return state;
    }
  }
};

export default propertyDevReducer;
